import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { VerifyCNS } from 'src/app/shared/custom-validators/cns.validator';
import { JourneyStageEnum } from 'src/app/shared/enum/journey-stage.enum';
import { UbsScreenEnum } from 'src/app/shared/enum/ubs-screen.enum';
import { WebhookCpfService } from 'src/app/shared/services/API/orchestrator-integration/webhook-cpf.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { UBSSearchPatientRequest } from 'src/app/shared/services/requests/orchestrator-integration/ubs-search-patient.request';
import { UBSSearchResponse } from 'src/app/shared/services/responses/orchestrator-integration/ubs-search.response';
import { WebhookStruct } from 'src/app/shared/services/structs/Integration/webhook-struct';
import { DowntimeService } from '../../downtime.service';
import { PatientData, UBSConfigData, UtilsUBSService } from '../../utils-ubs.service';
import { GetPatientByCpfService } from 'src/app/shared/services/API/medical-record/get-patiet-by-cpf.service';
import { PatientStruct } from 'src/app/shared/services/structs/medical-record/patient.struct';
import { UBSDataSectionService } from 'src/app/shared/services/API/ubs-health-promotion/ubs-data-section.service';
import { UbsWebhookService } from 'src/app/shared/services/API/orchestrator-patient/ubs-webhook.service';
import { UBSWebhookPatientStruct } from 'src/app/shared/services/structs/orchestrator-patient/ubs-webhook-patient.struct';

@Component({
  selector: 'app-cns-register',
  templateUrl: './cns-register.component.html',
  styleUrls: ['./cns-register.component.css']
})
export class CnsRegisterComponent implements OnInit, OnDestroy {

  constructor(
    private maskService: MaskService,
    private formBuilder: FormBuilder,
    private router: Router,
    private utilsUBSService: UtilsUBSService,
    private downtimeService: DowntimeService,
    private ubsWebhookService: UbsWebhookService,
    private webhookCpfService: WebhookCpfService,
    public dialog: MatDialog,
    @Inject(LOCALE_ID) public locale: string,
    private getPatient: GetPatientByCpfService,
    private ubsDataSectionService: UBSDataSectionService,
  ) { }

  private patientData: PatientData = new PatientData();
  public lgpd: boolean = false;
  public model: FormGroup = this.formBuilder.group({});
  public masks: Masks = new Masks();
  public isLoading = true;
  public audio = new Audio();
  public journeyStageId: number = JourneyStageEnum.Identificacao;
  public idUbsScreen: number = UbsScreenEnum.CpfRegister;
  public uBSConfigData: UBSConfigData = new UBSConfigData();
  public pageIndex: number = 0;
  public downtime: boolean = false;


  ngOnInit(): void {
    this.uBSConfigData = this.utilsUBSService.getUBSData();

    if (!this.uBSConfigData || !this.uBSConfigData.listUBSStruct) {
      this.router.navigate(['/ubs/erro']);
    }
    this.pageIndex = this.uBSConfigData.listUBSStruct.findIndex(x => x.idUBSScreen == this.idUbsScreen);

    if (this.pageIndex == -1) {
      this.router.navigate(['/ubs/erro']);
    }

    this.masks = this.maskService.getMasks();
    this.model = this.formBuilder.group({
      cns: ['', [
        Validators.required,
        VerifyCNS(),
      ]],
    });
    this.isLoading = false;
    this.downtimeService.startTimer(300000);
    this.downtimeService.watcher().subscribe((res: any) => {
      if (res) {
        if (alert!) {
          this.utilsUBSService.createDowntime(this.downtime = true);
          this.downtimeService.stopTimer();
          this.router.navigateByUrl('ubs/welcome');
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.audio.pause();
    this.downtimeService.stopTimer();
  }

  submit() {
    if (!this.model.valid) {
      return;
    }

    this.audio.pause();
    this.isLoading = true;

    let cns = this.model.get('cns')!.value.replace(/[^0-9]+/g, '');
    this.patientData.cns = cns;

    let request = new UBSSearchPatientRequest();
    request.cns = cns;
    request.url = '';
    request.token = '';
    request.guid = '';

    this.callSearchPatient(request);
  }

  playAudio() {
    this.audio.src = `../assets/audio/${this.locale}/cns-request.mp3`;
    this.audio.load();
    this.audio.play();
    this.audio.remove();
  }

  goBack() {
    this.downtimeService.stopTimer();
    this.audio.pause();

    let visitedPages = this.utilsUBSService.getListVisitidePages();
    let lastPage = visitedPages.pop()
    this.utilsUBSService.updateListVisitidePages(visitedPages);
    this.router.navigate([lastPage]);

    //this.router.navigate([`ubs/cpf-register`]);
  }

  goCompleteName() {
    this.downtimeService.stopTimer();
    this.audio.pause();
    this.saveLastPage();
    this.router.navigate([`ubs/conplete-name-register`]);
  }

  callSearchPatient(request: UBSSearchPatientRequest){  
    this.isLoading = true;
    this.patientData.existsInBaseData = true;
    let healthUnit = this.utilsUBSService.getHealthUnit();
    request.isFullTermPatientSearch = false;

    let webhookStruct: WebhookStruct = this.utilsUBSService.getWebhook();
    if (webhookStruct){
      request.url = webhookStruct.url;
      request.token = webhookStruct.token;
      request.guid = webhookStruct.guid;
    }

    let jsonListIdHealthUnit = null;
    if(healthUnit.listIdHealthUnitInGroup)
      jsonListIdHealthUnit = JSON.stringify(healthUnit.listIdHealthUnitInGroup);

    this.ubsWebhookService.uBSSearchPatient(null, healthUnit.idHealthUnit!, false, request.cns, jsonListIdHealthUnit!, request).subscribe({
      next: (response) => {
        if ((response.isError && response.errorCode == 1 && webhookStruct && !response.patientMedicalRecordStruct) || 
            (!response.isError && !response.patientMedicalRecordStruct && !response.uBSWebhookPatientStruct)) {
              this.downtimeService.stopTimer();
              this.patientData.existsInBaseData = false;
              this.patientData.searchByCNS = true;
              this.utilsUBSService.createPatientData(this.patientData);
              this.goCompleteName();
              this.isLoading = false;
              return;
        }
        else if (response.isError) {
          this.isLoading = false;
          this.downtimeService.stopTimer();
          this.router.navigate(['/ubs/erro']);
          return;
        }
        else{
          if (response.patientMedicalRecordStruct){
            this.mapToPatientMedicalRecordData(response.patientMedicalRecordStruct);
            this.getAditionalPatientData(response.patientMedicalRecordStruct.idPatient!);
          }
          else {
            this.mapToPatientData(response.uBSWebhookPatientStruct);
            this.getAditionalPatientData(response.uBSWebhookPatientStruct.idPatient!);
          } 

          this.utilsUBSService.createPatientData(this.patientData);
          this.downtimeService.stopTimer();
          this.saveLastPage();
          this.router.navigate([`ubs${this.uBSConfigData.listUBSStruct[this.pageIndex + 1].screenUrl}`]);          
          this.isLoading = false;
          return;
        }        
      },
      error: (error) => {
        console.log(error)
        this.isLoading = false;
        this.downtimeService.stopTimer();
        this.router.navigate(['/ubs/erro']);
      }
    });
  }

  getAditionalPatientData(idPatient: number) {
    this.ubsDataSectionService.getUBSDataSection(idPatient).subscribe((response) => {
      if (response.ubsDataSection) {
        this.patientData.idGender = response.ubsDataSection.idUbsGender;
        this.patientData.householdIncome = response.ubsDataSection.householdIncome;
        this.patientData.ethnicity = response.ubsDataSection.idEthnicityGroup;
      }
      this.utilsUBSService.createPatientData(this.patientData);
    },
      (error) => {
        console.log(error);
      })
  }

  mapToPatientData(data: UBSWebhookPatientStruct) {
    this.patientData.idPatient = data.idPatient;
    this.patientData.cpf = data.cpf;
    this.patientData.cns = data.cns;
    this.patientData.name = data.name;
    this.patientData.birthDate = data.birthDate;
    this.patientData.motherName = data.motherName;
  }

  mapToPatientMedicalRecordData(data: PatientStruct) {
    this.patientData.idPatient = data.idPatient;
    this.patientData.cpf = data.cpf;
    this.patientData.cns = data.cns;
    this.patientData.name = data.patientName;
    this.patientData.birthDate = data.birthDate;
    this.patientData.motherName = data.motherName;
  }

  saveLastPage(){
    let visitedPages = this.utilsUBSService.getListVisitidePages();
    if(!visitedPages)
      visitedPages = [];
    visitedPages.push(this.router.url);
    this.utilsUBSService.updateListVisitidePages(visitedPages);
  }
}